// Two-layer roles disabled: ['ambassador_1', 'ambassador_2', 'referee'].
// ambassador_2 remains the compatibility key for the single direct ambassador.
export const rewardRoles = ['ambassador_2', 'referee']
export const rewardAspects = ['order_reward', 'cashback']
export const cashbackRoles = ['ambassador_2']

export function rewardAspectsForRole (role) {
  return role === 'referee' ? ['order_reward'] : rewardAspects
}

const enabled = value => value === true || value === 1 || value === '1'
const present = value => value !== null && value !== undefined && value !== ''

export function emptyRule () {
  return { type: 'NONE', value: null, coupon_id: null, reward_type: null }
}

export function hydrateRewardSettings (row = {}) {
  const settings = {}
  rewardRoles.forEach(role => {
    settings[role] = {}
    rewardAspectsForRole(role).forEach(aspect => { settings[role][aspect] = emptyRule() })
  })
  // Keep older campaigns editable without dropping a combined fixed + percent reward.
  const legacyOrder = prefix => {
    const fixed = row[prefix + '_fixed']
    const percent = row[prefix + '_percent']
    if (present(fixed) && present(percent)) {
      return Object.assign(emptyRule(), { type: 'LEGACY', fixed, percent })
    }
    if (present(fixed)) return Object.assign(emptyRule(), { type: 'FLAT', value: Number(fixed) })
    if (present(percent)) return Object.assign(emptyRule(), { type: 'PERCENT', value: Number(percent) })
    return emptyRule()
  }
  settings.referee.order_reward = legacyOrder('referee_reward')
  settings.ambassador_2.order_reward = legacyOrder('ambassador_order_reward')
  if (enabled(row.ambassador_cashback_active)) {
    const flat = enabled(row.ambassador_cashback_is_flat) || String(row.ambassador_cashback_amount_type).toUpperCase() === 'FLAT'
    settings.ambassador_2.cashback = Object.assign(emptyRule(), {
      type: flat ? 'FLAT' : 'PERCENT',
      value: flat ? row.ambassador_cashback_fixed : row.ambassador_cashback_percent
    })
  }
  rewardRoles.forEach(role => {
    rewardAspectsForRole(role).forEach(aspect => {
      const saved = row.reward_settings && row.reward_settings[role] && row.reward_settings[role][aspect]
      if (saved) settings[role][aspect] = aspect === 'cashback' && saved.type === 'COUPON' ? emptyRule() : Object.assign(emptyRule(), saved)
    })
  })
  return settings
}

export function serializeRewardSettings (settings, cashbackEnabled) {
  const result = {}
  rewardRoles.forEach(role => {
    result[role] = {}
    rewardAspectsForRole(role).forEach(aspect => {
      const rule = aspect === 'cashback' && (!cashbackEnabled || settings[role][aspect].type === 'COUPON') ? emptyRule() : settings[role][aspect]
      // Omission preserves the API's original combined reward until the user replaces it.
      if (rule.type === 'LEGACY') return
      const saved = { type: rule.type }
      if (rule.type === 'COUPON') saved.coupon_id = Number(rule.coupon_id)
      if (rule.type === 'FLAT' || rule.type === 'PERCENT') {
        saved.value = Number(rule.value)
        if (present(rule.reward_type)) saved.reward_type = Number(rule.reward_type)
      }
      result[role][aspect] = saved
    })
  })
  return result
}

export function validateRewardSettings (settings, orderEnabled, cashbackEnabled) {
  const errors = {}
  rewardRoles.forEach(role => {
    rewardAspectsForRole(role).forEach(aspect => {
      if (!(aspect === 'order_reward' ? orderEnabled : cashbackEnabled)) return
      const rule = settings[role][aspect]
      const key = role + '.' + aspect
      if (rule.type === 'COUPON' && (!present(rule.coupon_id) || !Number.isInteger(Number(rule.coupon_id)) || Number(rule.coupon_id) <= 0)) {
        errors[key] = 'couponRequired'
      }
      if (rule.type === 'FLAT' || rule.type === 'PERCENT') {
        const amount = Number(rule.value)
        if (!present(rule.value) || !isFinite(amount) || amount < 0 || (rule.type === 'PERCENT' && amount > 100)) {
          errors[key] = rule.type === 'PERCENT' ? 'percentInvalid' : 'amountInvalid'
        }
      }
    })
  })
  return errors
}

export function describeRule (rule, t, defaultType = 1, coupons = []) {
  if (rule.type === 'NONE') return t('referralProgram.v2.none')
  if (rule.type === 'COUPON') {
    const coupon = coupons.find(item => Number(item.id) === Number(rule.coupon_id))
    return t('referralProgram.v2.coupon') + (coupon ? ': ' + coupon.name : ' #' + (rule.coupon_id || '—'))
  }
  const destination = Number(rule.reward_type || defaultType) === 2
    ? t('referralProgram.rewardTypeWallet') : t('referralProgram.rewardTypeLoyaltyPoints')
  if (rule.type === 'LEGACY') return rule.fixed + ' + ' + rule.percent + '% · ' + destination
  return (present(rule.value) ? rule.value : '—') + (rule.type === 'PERCENT' ? '%' : '') + ' · ' + destination
}

export function summarizeRewards (row, aspect, t, coupons = []) {
  if (aspect === 'order_reward' && !enabled(row.order_rewards_active)) return t('referralProgram.rewardSummaryDisabled')
  const settings = hydrateRewardSettings(row)
  const summaries = rewardRoles.filter(role => settings[role][aspect] && settings[role][aspect].type !== 'NONE').map(role => {
    return t('referralProgram.v2.' + role) + ': ' + describeRule(settings[role][aspect], t, row.reward_type, coupons)
  })
  return summaries.join(' / ') || t('referralProgram.rewardSummaryDisabled')
}

export function recordedRoleRewards (row, role, t) {
  if (!Array.isArray(row.reward_details)) return null
  return row.reward_details.filter(detail => detail.role === role).map(detail => {
    const destination = Number(detail.reward_type) === 2
      ? t('referralProgram.rewardTypeWallet') : t('referralProgram.rewardTypeLoyaltyPoints')
    return t('referralProgram.v2.' + detail.aspect) + ': ' + (detail.type === 'COUPON'
      ? t('referralProgram.v2.coupon') + ' #' + detail.coupon_id
      : Number(detail.amount).toFixed(2) + ' · ' + destination)
  })
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Marketing/Referral/referralRewardSettings.js